/**
 * Strips surrounding quotes (single or double) from a string
 * @param str - The string to strip quotes from
 * @returns The string without surrounding quotes
 */
export const stripQuotes = (str: string): string => str.replace(/^["']|["']$/g, '');
